@if (open) {
  <button
    type="button"
    class="sidebar-backdrop"
    (click)="sidebarClosed.emit()"
    [attr.aria-label]="T.sidebar.closeBackdropAria"
    data-testid="sidebar-backdrop"
  ></button>
}

<aside class="sidebar-drawer" [class.open]="open" [class.collapsed]="collapsed">
  <header class="sidebar-brand">
    <img
      src="assets/images/OmniFlow-Logo.png"
      class="sidebar-brand__logo"
      [alt]="T.common.appName"
    />
    <button
      icon-button
      variant="ghost"
      symbolName="close"
      size="sm"
      class="sidebar-close"
      (click)="sidebarClosed.emit()"
      [attr.aria-label]="T.sidebar.closeMenuAria"
      data-testid="sidebar-close-btn"
    ></button>
  </header>

  <nav class="sidebar-nav">
    @for (group of visibleNavGroups(); track group.label) {
      @if (group.children) {
        <div class="nav-section">
          <span class="nav-section__label">{{ group.label }}</span>
          @for (child of group.children; track child.route) {
            <button
              type="button"
              class="nav-item"
              [class.active]="isActive(child.route)"
              [disabled]="
                child.route !== 'dashboard' && !child.noLock && navItemsLocked
              "
              [title]="
                child.route !== 'dashboard' && !child.noLock && navItemsLocked
                  ? T.sidebar.locationLockedTitle
                  : (collapsed ? child.label : '')
              "
              (click)="navigate(child)"
              [attr.data-testid]="'sidebar-nav-item-' + child.route"
            >
              <app-svg-icon [name]="child.icon" class="nav-item__icon"></app-svg-icon>
              <span class="nav-item__label">{{ child.label }}</span>
              @if (isActive(child.route)) {
                <span class="nav-item__dot" aria-hidden="true"></span>
              }
            </button>
          }
        </div>
      } @else {
        <div class="nav-section">
          <span class="nav-section__label">{{ group.label }}</span>
          <button
            type="button"
            class="nav-item"
            [class.active]="isActive(group.route!)"
            [disabled]="navItemsLocked"
            [title]="navItemsLocked ? T.sidebar.locationLockedTitle : (collapsed ? group.label : '')"
            (click)="navigateGroup(group)"
            [attr.data-testid]="'sidebar-nav-item-' + group.route"
          >
            <app-svg-icon [name]="group.icon" class="nav-item__icon"></app-svg-icon>
            <span class="nav-item__label">{{ T.common.open }}</span>
            @if (isActive(group.route!)) {
              <span class="nav-item__dot" aria-hidden="true"></span>
            }
          </button>
        </div>
      }
    }
  </nav>

  <div class="sidebar-footer">
    <button
      type="button"
      class="signout-btn"
      (click)="signOut()"
      [title]="collapsed ? T.sidebar.signOut : T.sidebar.signOutTitle"
      data-testid="sidebar-signout-button"
    >
      <span class="signout-btn__label">{{ T.sidebar.signOut }}</span>
      <app-svg-icon name="chevron-right" class="signout-btn__icon"></app-svg-icon>
    </button>
  </div>
</aside>
